import React, { createContext, useContext, useState, useEffect } from 'react';
import type { ReactNode } from 'react';
import api from '../lib/api/client';

interface FeatureFlags {
  calendarAvailability: boolean;
  compatibilityQuiz: boolean;
  profileInsights: boolean;
  twoFactorAuth: boolean;
  backgroundChecks: boolean;
  blog: boolean;
  forum: boolean;
  referralProgram: boolean;
  achievements: boolean;
  dateRecap: boolean;
  smartMatchingV3: boolean;
  expandedCities: boolean;
  advancedAI: boolean;
  premiumElite: boolean;
  marketingBlog: boolean;
  eventsCalendar: boolean;
  [key: string]: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  calendarAvailability: false,
  compatibilityQuiz: false,
  profileInsights: false,
  twoFactorAuth: false,
  backgroundChecks: false,
  blog: false,
  forum: false,
  referralProgram: false,
  achievements: false,
  dateRecap: false,
  smartMatchingV3: true,
  expandedCities: true,
  advancedAI: false,
  premiumElite: false,
  marketingBlog: false,
  eventsCalendar: false,
};

const FeatureFlagContext = createContext<FeatureFlags>(DEFAULT_FLAGS);

export const useFeatureFlags = (): FeatureFlags => useContext(FeatureFlagContext);

export const FeatureFlagProvider = ({ children }: { children: ReactNode }) => {
  const [flags, setFlags] = useState<FeatureFlags>(DEFAULT_FLAGS);

  useEffect(() => {
    let cancelled = false;
    api.get('/features').then((res) => {
      if (!cancelled && res.data) {
        setFlags((prev) => ({ ...prev, ...res.data }));
      }
    }).catch(() => { /* fallback to defaults silently */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
